import React, { useCallback, useEffect, useRef, useState } from 'react'
import CenterContent from '../Components/CenterContent/CenterContent'
import classes from './report.module.css'
import svodClasses from './svod.module.css'
import http from '../Service/http'
import { useReactToPrint } from 'react-to-print'
import Select from 'react-select'

function SvodReportContainer() {
	const [years, setYears] = useState([])
	const [selectedYear, setSelectedYear] = useState(null)
	const [reportData, setReportData] = useState([])
	const [loading, setLoading] = useState(false)
	const ref = useRef()

	const getSvodReport = useCallback(async (year) => {
		if (!year) return
		setLoading(true)
		try {
			const res = await http.post('/select/svod', { year })
			if (res.data?.data) {
				setReportData(res.data.data)
			}
		} finally {
			setLoading(false)
		}
	}, [])

	const getYears = useCallback(async () => {
		const res = await http.post('/select/eduyear/list')
		if (res.data?.data) {
			const options = res.data.data.map(y => ({
				value: y.id_a_year,
				label: y.p32
			}))
			setYears(options)

			const defaultOption = options.find(
				(_, i) => res.data.data[i].defaultValue === 1
			)
			if (defaultOption) {
				setSelectedYear(defaultOption)
				getSvodReport(defaultOption.value)
			}
		}
	}, [getSvodReport])

	const handleYearChange = (option) => {
		setSelectedYear(option)
		getSvodReport(option?.value)
	}

	const handlePrint = useReactToPrint({ content: () => ref.current })

	useEffect(() => {
		getYears()
	}, [getYears])

	const total = reportData.reduce((sum, item) => sum + (item.kol || 0), 0)

	return (
		<CenterContent>
			<div className={classes.head_block}>
				<div className={svodClasses.controls}>
					<div style={{ width: 200 }}>
						<Select
							placeholder='Учебный год'
							options={years}
							value={selectedYear}
							onChange={handleYearChange}
							isSearchable={false}
						/>
					</div>
					<button
						className={classes.button_modal}
						onClick={handlePrint}
						disabled={!reportData.length}
					>
						Печать
					</button>
				</div>

				<div className={classes.data_block} ref={ref}>
					<p className={svodClasses.title}>
						Отчет выданных справок через АВН «Единое окно».
					</p>
					{loading ? (
						<p className={svodClasses.empty}>Загрузка...</p>
					) : (
						<table className={`table ${svodClasses.table}`}>
							<thead>
								<tr>
									<th className={svodClasses.col_num}>№</th>
									<th>Вид справки</th>
									<th className={svodClasses.col_count}>Количество (штук)</th>
								</tr>
							</thead>
							<tbody>
								{reportData.length === 0 ? (
									<tr>
										<td colSpan={3} className={svodClasses.empty}>
											{selectedYear ? 'Нет данных' : 'Выберите учебный год'}
										</td>
									</tr>
								) : (
									<>
										{reportData.map((item, index) => (
											<tr key={item.id_okno_document}>
												<td className='text-center'>{index + 1}</td>
												<td>{item.okno_document}</td>
												<td className='text-center'>{item.kol}</td>
											</tr>
										))}
										<tr className={svodClasses.total_row}>
											<td colSpan={2} className='text-right'>
												<strong>Итого:</strong>
											</td>
											<td className='text-center'>
												<strong>{total}</strong>
											</td>
										</tr>
									</>
								)}
							</tbody>
						</table>
					)}
				</div>
			</div>
		</CenterContent>
	)
}

export default SvodReportContainer
